/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  flowStats(campaignId) {
    return axios.get(`${this.url}/${campaignId}/flow_stats`);
  }

  createAbTest(campaignId, data) {
    return axios.post(`${this.url}/${campaignId}/ab_tests`, data);
  }

  estimateCost(campaignId, data) {
    return axios.post(`${this.url}/${campaignId}/estimate_cost`, data);
  }

  aiPreview(campaignId, data) {
    return axios.post(`${this.url}/${campaignId}/ai_preview`, data);
  }

  pause(campaignId) {
    return axios.post(`${this.url}/${campaignId}/pause`);
  }

  resume(campaignId) {
    return axios.post(`${this.url}/${campaignId}/resume`);
  }

  testMessage(campaignId, data) {
    return axios.post(`${this.url}/${campaignId}/test_message`, data);
  }

  retryFailed(campaignId, data = {}) {
    return axios.post(`${this.url}/${campaignId}/messages/retry_failed`, data);
  }

  retryContact(campaignId, contactId) {
    return axios.post(`${this.url}/${campaignId}/messages/retry_failed`, {
      contact_ids: [contactId],
    });
  }

  validateNumbers(campaignId) {
    return axios.post(`${this.url}/${campaignId}/messages/validate_numbers`);
  }

  getStats(campaignId) {
    return axios.get(`${this.url}/${campaignId}/messages/stats`);
  }

  exportCsv(campaignId) {
    return axios.get(`${this.url}/${campaignId}/export`, {
      responseType: 'blob',
    });
  }

  getCampaignUsage() {
    return axios.get(`${this.url}/usage`);
  }

  // Contador ao vivo do nó Audiência do canvas
  audienceCount(labelIds, channel) {
    return axios.get(`${this.url}/audience_count`, {
      params: { label_ids: labelIds, channel },
    });
  }

  addCredits(amount) {
    return axios.post(`${this.url}/add_credits`, { amount });
  }
}

export default new CampaignsAPI();
